<div class="Customers overview-loyalty ui-g">

  <div class="ui-g-12 ui-lg-6">
    <h1 class="step-title">{{ 'store.loyalty_title' | translate }}</h1>
  </div>
  <div class="ui-g-12 ui-lg-12">
    <p-steps [model]="items" [(activeIndex)]="activeIndex" [readonly]="false"></p-steps>

    <kv-search-toolbar
            [dateBoxEnabled]="true"
            [date_structure]="searchModel.date_structure"
            [card_modes]="searchModel.card_modes"
            [clusters]="searchModel.cluster_list"
            [customersBoxEnabled]="false"
            [clusterFieldEnabled]="false"
            [selectedElapsedStart]="searchModel.selectedStartDate"
            [selectedElapsedEnd]="searchModel.selectedEndDate"
            [group_types]="searchModel.group_types"
            [groups]="searchModel.groups"
            [areas]="searchModel.areas"
            [stores]="searchModel.stores"
            [disableMutualExclusivity]="false"
            [storeSelectionMode]="'single'"
            [groupTypesFieldEnabled]="false"
            [groupFieldEnabled]="false"
            [areaFieldEnabled]="false"
            appQFilter
            (onQFilter)="ApplyResult($event)"
    ></kv-search-toolbar>

    <div class="overview-container card ui-g-nopad">
      <app-store-customers-kpi [hidden]="activeIndex !== 0" ></app-store-customers-kpi>
      <app-store-customers-loyalty [hidden]="activeIndex !== 1" ></app-store-customers-loyalty>
    </div>

  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/store/store-customers/store-customers.component.html